export const LOGO = "/logo.png";

export const IMG = {
  hero: "https://images.unsplash.com/photo-1743356174397-d6da6f014f8f?q=80&w=2400&auto=format&fit=crop",
  about: "https://images.unsplash.com/photo-1606942095201-bd139f63b2e3?q=80&w=1400&auto=format&fit=crop",
};

export const NAV_LINKS = [
  { label: "About", id: "about" },
  { label: "Destinations", id: "destinations" },
  { label: "Experiences", id: "experiences" },
  { label: "Why Mirevaa", id: "why-mirevaa" },
  { label: "Journal", id: "inspiration" },
];

export const DESTINATIONS = [
  {
    slug: "new-zealand",
    name: "New Zealand",
    tag: "South Pacific",
    blurb: "Fiordlands, alpine lakes and vineyard valleys — New Zealand is nature at its most cinematic, best explored slowly and in depth.",
    image: "https://images.unsplash.com/photo-1591640040362-f55d95a6b2bc?q=80&w=1400&auto=format&fit=crop",
    intro: "Few places reward the unhurried traveller like New Zealand. From the mirror-still waters of Milford Sound to the vineyards of Hawke's Bay and the geothermal wonders of the north, it is a country made for journeys that unfold day by day.",
    highlights: [
      "Scenic fjord cruises through Milford Sound",
      "Private wine tours in Central Otago and Hawke's Bay",
      "Helicopter picnics over alpine glaciers",
      "Maori cultural experiences in Rotorua",
    ],
    when: "October to April brings long, warm days — though winter transforms the South Island into a quiet, dramatic escape.",
    style: "Self-drive grand tours, private guiding and luxury lodges, paced generously.",
  },
  {
    slug: "australia",
    name: "Australia",
    tag: "South Pacific",
    blurb: "From the sails of Sydney to the Great Barrier Reef and the red heart of the outback — vast, radiant and full of contrast.",
    image: "https://images.unsplash.com/photo-1590716209211-ea74d5f63573?q=80&w=1400&auto=format&fit=crop",
    intro: "Australia is a continent of moods: harbourside mornings in Sydney, sailing the Whitsundays, rainforest boardwalks in Queensland and the elemental stillness of Uluru at dusk. We shape it all around the pace you travel at.",
    highlights: [
      "Private harbour dining and Opera House evenings",
      "The Great Barrier Reef by helicopter and yacht",
      "Uluru at sunrise with an Indigenous guide",
      "Barossa Valley and Margaret River wine country",
    ],
    when: "Spring and autumn suit most regions; the tropical north is at its best in the dry season, May to October.",
    style: "City stays, coastal resorts and outback lodges connected by scenic flights.",
  },
  {
    slug: "europe",
    name: "Europe",
    tag: "Continent",
    blurb: "The Amalfi Coast, the Swiss Alps, the Aegean and beyond — Europe layered with art, flavour and timeless style.",
    image: "https://images.unsplash.com/photo-1694875374312-3adad994c3cf?q=80&w=1400&auto=format&fit=crop",
    intro: "Europe is where the love of the grand journey begins: cliff-hung villages above the Mediterranean, chalets under the Alps, quiet galleries and long lunches. However many times you return, it always offers another chapter.",
    highlights: [
      "The Amalfi Coast and Capri by private boat",
      "Stays in grand Alpine hotels and mountain chalets",
      "Aegean island-hopping with private skippers",
      "Guided journeys through Europe's great museums and palaces",
    ],
    when: "Late spring (May–June) and early autumn (September–October) offer warm days without the peak-season crowds.",
    style: "Rail journeys, villa stays and city escapes, tailored season by season.",
  },
  {
    slug: "japan",
    name: "Japan",
    tag: "East Asia",
    blurb: "Ancient Kyoto gardens, Tokyo's quiet luxuries and the fleeting beauty of cherry blossom — Japan is precision and poetry.",
    image: "https://images.unsplash.com/photo-1707474893587-a37a9cf1b555?q=80&w=1400&auto=format&fit=crop",
    intro: "Japan asks to be travelled attentively: a tea ceremony measured in centuries, a ryokan dinner served course by course, mountain temples wrapped in autumn colour. Our itineraries pair the icons with the quiet moments in between.",
    highlights: [
      "Kyoto's temple gardens at first light",
      "Ryokan stays with private onsen",
      "Culinary journeys through Tokyo's finest counters",
      "Cherry-blossom and autumn-foliage timing, planned to the week",
    ],
    when: "Late March to April for cherry blossom; November for fiery autumn maples — both best booked well in advance.",
    style: "Rail journeys, boutique ryokans and design hotels, guided or independent.",
  },
  {
    slug: "southeast-asia",
    name: "Southeast Asia",
    tag: "Asia",
    blurb: "Bali's emerald interiors, Thai islands and Vietnamese street kitchens — Southeast Asia is warm in every sense.",
    image: "https://images.unsplash.com/photo-1761521688845-49ac945ef438?q=80&w=1400&auto=format&fit=crop",
    intro: "Southeast Asia is made for journeys that blend indulgence with discovery: dawn rituals in Balinese temples, limestone bays in Vietnam, night markets in Bangkok and some of the world's most gracious resorts.",
    highlights: [
      "Cliff-top villas and jungle retreats in Bali",
      "Private long-tail boat days in Phang Nga Bay",
      "Hoi An and the lantern evenings of old Vietnam",
      "Bespoke spa and wellness journeys",
    ],
    when: "November to March is the classic dry window for much of the region; Bali shines from April to October.",
    style: "Resort stays woven with local experiences, family-friendly or couples-focused.",
  },
  {
    slug: "maldives",
    name: "Maldives",
    tag: "Indian Ocean",
    blurb: "Turquoise lagoons, overwater villas and sandbanks that appear with the tide — the Maldives, distilled.",
    image: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?q=80&w=1400&auto=format&fit=crop",
    intro: "The Maldives is the world's simplest luxury: water, sky and silence. Whether it is honeymoon seclusion, a diving journey across the atolls or a multi-island escape, we match you to the right atoll and the right villa.",
    highlights: [
      "Overwater villas with private pools",
      "Sandbank picnics and sunset dhoni cruises",
      "World-class house-reef snorkelling and diving",
      "Seaplane arrivals over the atolls",
    ],
    when: "December to April for dry, luminous days; shoulder months bring quieter lagoons and softer rates.",
    style: "One-island seclusion or twin-island escapes, honeymoon-tuned.",
  },
  {
    slug: "middle-east",
    name: "Middle East",
    tag: "Arabian Gulf",
    blurb: "Futuristic skylines and endless dunes — the Gulf pairs glamour with desert stillness.",
    image: "https://images.unsplash.com/photo-1612899326681-66508905b4ce?q=80&w=1400&auto=format&fit=crop",
    intro: "The Middle East rewards travellers who look past the skyline: dune dinners under the stars, the museums of Abu Dhabi, the wadis and fjords of Oman. It is an easy, indulgent escape — and a surprisingly soulful one.",
    highlights: [
      "Desert suites and dune dinners outside Dubai",
      "Sheikh Zayed Grand Mosque and Louvre Abu Dhabi, privately guided",
      "Oman's wadis, forts and Musandam fjords",
      "Beach resorts with effortless winter sun",
    ],
    when: "November to March, when the desert cools and the city terraces come alive.",
    style: "City-and-desert combinations, family resorts or adult-only luxury.",
  },
  {
    slug: "beyond",
    name: "Beyond the Map",
    tag: "Your Choice",
    blurb: "Africa's plains, the South Pacific, the Americas — tell us where your story is set, and we will design it.",
    image: "https://images.unsplash.com/photo-1501785888041-af3ef285b470?q=80&w=1400&auto=format&fit=crop",
    intro: "Mirevaa Journeys is destination-fluid by design. From safari camps in Africa to the islands of the South Pacific and the great cities of the Americas — if it can be travelled well, it can be travelled with us. Your curiosity leads; we handle everything else.",
    highlights: [
      "Safaris across Africa's great conservancies",
      "South Pacific island escapes",
      "North and South America, city to wilderness",
      "Multi-country world journeys, planned end to end",
    ],
    when: "Everywhere has a season — share your dates and we will design around them.",
    style: "Completely bespoke — defined by your interests, not a map.",
  },
];

export const EXPERIENCES = [
  {
    n: "01",
    title: "Romantic Escapes",
    line: "For the two of you, and no one else.",
    copy: "Honeymoons, anniversaries and escapes that whisper rather than shout. Private dinners, sunset sails and villas chosen for the view you will remember long after.",
    image: "https://images.unsplash.com/photo-1496602910407-bacda74a0fe4?q=80&w=1200&auto=format&fit=crop",
  },
  {
    n: "02",
    title: "Family Adventures",
    line: "Journeys that give every generation a story.",
    copy: "Thoughtfully paced family holidays with stays and activities tuned to children, parents and grandparents alike — adventure for the young, ease for everyone.",
    image: "https://images.unsplash.com/photo-1568392862895-f949b6a93d60?q=80&w=1200&auto=format&fit=crop",
  },
  {
    n: "03",
    title: "Luxury Journeys",
    line: "The rarest luxury is how it feels.",
    copy: "Luxury is not only about stars. It is about how the journey feels. We design for the feeling: the suite that is ready early, the guide who knows which door to slip through, the day with nothing forced.",
    image: "https://images.unsplash.com/photo-1561501900-3701fa6a0864?q=80&w=1200&auto=format&fit=crop",
  },
  {
    n: "04",
    title: "Special Occasions",
    line: "Milestones, marked beautifully.",
    copy: "Milestone birthdays, anniversaries, retirements and proposals — celebrated in settings that feel chosen, not booked. Tell us the moment; we will build the memory.",
    image: "https://images.unsplash.com/photo-1576343547429-1a9ac89d7013?q=80&w=1200&auto=format&fit=crop",
  },
  {
    n: "05",
    title: "Cultural Experiences",
    line: "Travel that goes deeper than sightseeing.",
    copy: "Meet artisans, kitchens and traditions through the people who live them. Our cultural journeys favour access, context and time over checklists.",
    image: "https://images.unsplash.com/photo-1551241090-67de81d3541c?q=80&w=1200&auto=format&fit=crop",
  },
  {
    n: "06",
    title: "Slow & Immersive Travel",
    line: "Stay longer. See more.",
    copy: "Fewer places, longer stays, deeper roots. Slow-travel itineraries trade rushed check-ins for morning markets, long lunches and days that breathe.",
    image: "https://images.unsplash.com/photo-1789700536824-25581b5732ab?q=80&w=1200&auto=format&fit=crop",
  },
];

export const WHY_POINTS = [
  {
    icon: "route",
    title: "Personalised Travel Planning",
    copy: "Every journey starts with a conversation about you — not a brochure. Your interests, pace and dreams shape the plan.",
  },
  {
    icon: "pen",
    title: "Tailor-Made Itineraries",
    copy: "No two Mirevaa journeys are alike. Each itinerary is drawn from scratch, day by considered day.",
  },
  {
    icon: "gem",
    title: "Handpicked Stays & Experiences",
    copy: "Hotels, villas and experiences chosen with care and trusted partners on the ground — never from a list.",
  },
  {
    icon: "feather",
    title: "Attention to Detail",
    copy: "Transfers timed, tables remembered, surprises planned. The small things are the whole point.",
  },
  {
    icon: "chat",
    title: "Personal Travel Assistance",
    copy: "From first enquiry to safe return, you plan with one person — reachable, responsive and invested.",
  },
  {
    icon: "map",
    title: "Thoughtful Destination Planning",
    copy: "We match destinations to seasons, occasions and energy — so a place is right not just on paper, but for you.",
  },
];

export const ARTICLES = [
  {
    slug: "kyoto-in-autumn",
    category: "Destination Guide",
    read: "8 min read",
    title: "Kyoto in Autumn: A Slower Way to See the City",
    excerpt: "When the maples burn gold and the tour buses thin by evening, Kyoto becomes a city best travelled at walking pace.",
    image: "https://images.unsplash.com/photo-1578469645742-46cae010e5d4?q=80&w=1400&auto=format&fit=crop",
    body: [
      "Ask anyone when to visit Kyoto and they will say cherry blossom season. Return the favour and keep it to yourself: autumn is when the city is at its most beautiful. From mid-November, the maple trees that fill its temple gardens turn copper and crimson, and the light in the late afternoons turns the whole valley the colour of amber.",
      "The secret is to begin early. At six in the morning the gravel paths of the great temple gardens are nearly empty; the monks are at their rituals and the maples hang still. By nine, the crowds arrive. We time our mornings accordingly — an unhurried garden, a proper breakfast, and only then the day's exploring.",
      "Kyoto rewards walking. The Philosopher's Path, the lanes of Gion, the tea houses tucked behind wooden doors — these are not sights to collect but streets to inhabit. Break the day with a proper lunch, a kaiseki table booked weeks ahead or a single perfect bowl of udon.",
      "Stay, if the journey allows, in a ryokan outside the centre: tatami rooms, private onsen, and dinners served course by course in your suite. It is the kind of stay that turns a city break into a journey you describe for years.",
      "Autumn dates shift with the weather each year. We track the forecasts and design the week around the colour — which is, in the end, what personalised planning is for.",
    ],
  },
  {
    slug: "maldives-beyond-the-villa",
    category: "Journal",
    read: "6 min read",
    title: "The Maldives, Beyond the Overwater Villa",
    excerpt: "There is a quieter Maldives — of house reefs, sandbank afternoons and long luminous evenings. Here is how we design it.",
    image: "https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?q=80&w=1400&auto=format&fit=crop",
    body: [
      "The overwater villa deserves its fame. Waking to the lagoon through a glass floor never quite loses its thrill. But the Maldives rewards travellers who treat the atoll as a place, not only a resort — and that begins with choosing the right one.",
      "Each atoll has a character: some face the open ocean with channels where mantas pass; others curve around shallow, glass-still lagoons perfect for swimming. We match the island to the traveller — divers to the channels, honeymooners to the quiet corners, families to the house reefs where turtles graze before breakfast.",
      "Then there is the pace. The finest Maldives days are often the emptiest: a dhoni boat at sunset, a sandbank that appears with the low tide, a private dinner set at the end of the jetty with nothing around it but water.",
      "For the more adventurous, the country opens up beautifully — seaplanes between islands, local island guesthouses, surf breaks, night fishing with the resort's crew. A twin-island journey, one lively and one hushed, is a particular favourite of ours.",
      "Whenever you go, go slowly. The Maldives is not a place to see; it is a place to be.",
    ],
  },
  {
    slug: "slow-days-amalfi-coast",
    category: "Travel Story",
    read: "7 min read",
    title: "Slow Days on the Amalfi Coast",
    excerpt: "Skip the ferry queues and the noon crowds: the coast reveals itself to those who stay for the evenings.",
    image: "https://images.unsplash.com/photo-1750098091219-4857ba88ab5a?q=80&w=1400&auto=format&fit=crop",
    body: [
      "The Amalfi Coast in high summer is one of the world's most beautiful traffic jams. Which is a pity, because the coast that remains after five in the evening — when the day-trippers' ferries pull away and the lemons glow in the warm light — is the one worth crossing an ocean for.",
      "Our advice is to stay longer and move less. Base yourself in one place, in a hotel with terraces above the water, and let the coast come to you: Positano early, Ravello late, Capri on a weekday with a private boat and a packed lunch from a trattoria that does not have a sign.",
      "Eat like a local late. Lunch is long, dinner longer. The pasta of the coast — scialatielli, nur the lemon-tinged seafood of Conca dei Marini — tastes best when nobody at the table is thinking about the next stop.",
      "Spring and October are the connoisseur's seasons: warm seas, cool evenings, and paths like the Walk of the Gods almost to yourself. Go in May and you may have it entirely alone.",
      "The Amalfi Coast does not need to be ticked off. It needs to be lingered in. That, more than anything, is the Mirevaa way.",
    ],
  },
];

export const CONTACT = {
  founder: "Pritha Samanta",
  role: "Founder | Travel Curator",
  location: "Kolkata, India",
  email: "hello@mirevaajourneys.com",
  site: "www.mirevaajourneys.com",
  siteUrl: "https://www.mirevaajourneys.com",
  social: "mirevaajourneys",
};
